import LocalizedStrings from 'react-localization';
import institutionalPages from './institutionalPages';
import masterPrograms from './masterPrograms.json';

export const SUPPORTED_LANGUAGES = ["en", "ps", "fa"];
export const RTL_LANGUAGES = ["ps", "fa"];

export const normalizeLanguage = (languageCode) =>
  SUPPORTED_LANGUAGES.includes(languageCode) ? languageCode : "en";

export const getLanguageDirection = (languageCode) =>
  RTL_LANGUAGES.includes(normalizeLanguage(languageCode)) ? "rtl" : "ltr";

export const setDocumentLanguage = (languageCode) => {
  const normalizedLanguage = normalizeLanguage(languageCode);
  if (typeof document !== "undefined") {
    const direction = getLanguageDirection(normalizedLanguage);
    const script = direction === "rtl" ? "arabic" : "latin";
    document.documentElement.lang = normalizedLanguage;
    document.documentElement.dir = direction;
    document.documentElement.dataset.language = normalizedLanguage;
    document.documentElement.dataset.script = script;
  }
};

let languages = new LocalizedStrings({
  en:{
    ...institutionalPages.en,
    ...masterPrograms.en,
    textDirection: "ltr",
    home: "Home",
    contact: "Contact",
    about: "About Us",
      vission_mission: "Vision & Mission",
      our_vission_and_mission: "Vision & Mission",
      chancellor_message: "Chancellor's Message",
      organizational_structure: "ORG Structure",
      stratigic_aim: "Stratigic Aim",
      academic_calendar: "Academic Calendar",
      aggrements: "Agreements",
      aggrement: "Agreements",

    a_pdc: "Professional Development",
      a_pdc_b: "Professional Development Board",


    academics_programs: "Academics Programs",
      academics: "Academics",
      a_quality_assurance: "Quality Assurance",
        a_aims: "Aims",
        a_self_assesment: "Self Assesment",
        a_annual_program_monitoring: "Annual Program Monitoring",
        a_councils_committees: "Councils & Committees",
        a_manual_policies: "Manual & Policies",
        a_capacity_building: "Capacity Building",
        accreditation: "Accreditation",
      a_bcs_computer_science: "Computer Science",
      a_bba_economics: "Economics",
        a_vission_mission: "Vision, Mission & About",
        a_curriculum: "Curriculum",
        a_organizational_structure: "Organizational Structure",
        a_aggrements: "Agreements",

    research: "Research",
      quality: "Quality",
      research_quality: "Research & quality",
      capacity_building: "Capacity Building",
      r_vission_mission: "Vision & Mission",
      manual_policies: "Manual & Policies",
      saba_magazine: "Saba Magazine",
      research_publications: "Research Publications",

    student: "Students",
      eligibility_criteria: "Eligibility Criteria",
      scholarships_financing: "Scholarships & Financing",
      migration_policy: "Migration Policy",
      semester_promotion_rules: "Semester Promotion Rules",
      penalties: "Penalties",


    saba_library: "Saba Library",
    news: "News",
    job_opportunity: "Job Opportunity",
    kankor: "Kankor",
      online_admission: "Online Admission",
      result: "Result",
      kankor_results: "Kankor Results",
      kankor_result_portal: "Official Result Portal",
      saba_university: "Saba University",
      student_id: "Student ID",
      student_name: "Student Name",
      father_name: "Father Name",
      grandfather_name: "Grandfather Name",
      selected_faculty: "Selected Faculty",
      kankor_marks: "Kankor Marks",
      result_status: "Result Status",
      student_type: "Student Type",
      kankor_status_pass: "Pass",
      kankor_status_fail: "Fail",
      grade_12: "Grade 12",
      grade_14: "Grade 14",
      maximum_marks: "Maximum Marks",
      passing_score: "Passing Score",
      invalid_marks: "Invalid Marks",
      marks_cannot_exceed: "Marks cannot exceed the allowed maximum.",
      student_photo: "Student Photo",
      enter_student_id: "Enter your Student ID",
      kankor_student_id_required: "Please enter your Student ID.",
      kankor_student_id_invalid: "Please enter a valid Student ID.",
      kankor_result_not_found: "No result was found for this Student ID.",
      kankor_result_lookup_error: "Result lookup is temporarily unavailable. Please try again.",
      kankor_result_share_description: "View this official public Kankor result from Saba University.",
      kankor_result_search_hint: "Search privately by Student ID to view your official result card.",
      kankor_share_copied: "Share link copied.",
      kankor_share_copy_failed: "Copy failed. Please copy the link manually.",
      kankor_share_ready: "Result link is ready to share.",
      kankor_result_not_found_title: "Result not found",
      kankor_result_not_found_detail: "The shared result may have been removed or the link may no longer be valid.",
      kankor_result_public_card: "Public Result Card",
      kankor_result_verified: "Verified public record",
      official: "Official",
      result_public_id: "Public Result ID",
      share_result: "Share Result",
      share_result_hint: "Send this safe public result link to friends or family.",
      share_result_link: "Share result link",
      copy_link: "Copy Link",
      print_result: "Print / Save as PDF",
      share: "Share",
    saba_economical_board: "Saba Economical Board",
    seb: "Saba Economical Board",
    nothing_to_show: "Nothing To Show Yet",
    no_posts: "No Posts To Show",
    posts: "Posts",
    post: "Post",
    chancellor_of_saba: "chancellor of saba university",
    achievements: "Achievements",
    annual_two_semesters: "Annual two semesters",
    a_about: "About",
    author: "Author",
    page: "Page",
    related: "Related",
    document: "Document",
    fullName: "Full Name",
    fatherName: "Father Name",
    faculty: "Faculty",
    faculties: "Faculties",
    id: "ID",
    yourDocuments: "Your Documents",
    logOut: "LogOut",
    graduated_date: "Alumni Date",
    menu: "MENU",
    saba_foundation: "Saba Foundation",
    foundation: "Saba Foundation",
    vission: "Vision",
    mission: "Mission",
    structure: "Structure",
    values: "Values",
    years_plane: "Five-Years Stratigic Plan",
    strategic_plane: "Strategic Plan",
    strategic_aims: "Strategic Aims",
    downloadPlanFile: "Download File",
    councils_and_committees: "Councils & Committees",
    academic_programs: "Academic Programs",
    your_opinion: "Your Opinion",
    write_opinion: "Write Your Opinion To Us",
    informational_technology: "Informational Technology",
    it: "Informational Technology",
    curriculum: "Curriculum",
    labs: "Labs",
    library: "Library",
    libraryinfos: "Library Information",
    semester_fee: "Semester Fee",
    software_engineering: "Software Engineering",
    se: "Software Engineering",
    information_system: "Information System",
    is: "Information System",
    national_economics: "National Economics",
    neco: "National Economics",
    banking: "Banking",
    beco: "Banking",
    business_administration: "Business & Administration",
    baeco: "Business & Administration",
    research_support: "Research Support",
    research_trainings: "Research Trainings",
    policies_and_procedures : "Policies & Procedures",
    research_papers_and_publication: "Research Papers & Publications",
    research_papers_and_publications: "Research Papers & Publications",
    scientific_and_research_magazine: "Scientific & Research Magazine",
    research_paper: "Research Papers",
    research_guide: "Research Guide",
    research_activities: "Research Activities",
    activities: "Activities",
    planed_researche : "Planed Researches",
    under_process_researche: "Under Process Researches",
    completed_researche: "Completed Researches",
    published_researche: "Published Researches",
    publishedresearches: "Published Researches",

    annual_professional_development_plan: "Annual Professional Development Plan",
    seminars_courses_workshop: "Seminars Courses Workshops",
    teacher: "Teachers",
    administrative_staff: "Administrative Staffs",
    society: "Society",
    periodic_program_review: "Periodic Program Review",
    internal_accreditation: "Internal Accreditation",
    national_accreditation: "National Accreditation",
    international_accreditation: "International Accreditation",
    offline_enrollment_requirement: "Offline Enrollment Requirements",
    kankor_guide: "Kankor Guide",
    kankor_registration_date : "Kankor Registration Date",
    enrolled : "Enrolled",
    general: "General",
    activity: "Activities",
    online_library : "Online Library",
    digital_library: "Digital Library",
    offline_library : "Offline Library",
    procedure: "Procedure",
    study_statistic: "Study Statistics",
    progressive_plan:"Progressive Plan",
    students_engagement:"Students Engagements",
    students_experience: "Students Experiences",
    tours_of_student: "Academic Tours of Students",
    students_statistic: "Students Statistics",
    statistic:"Statistics",
    statistics:"Statistics",
    tajil : "Tajil",
    deprived: "Deprived",
    chance: "Chance",
    re_enrollment: "Re-Enrollment",
    eresticate: "Eresticate",
    transformation: "Transformation",
    repeat: "Repeat",
    graduate: "Alumni",
    cs_graduate: "CS Alumni",
    eco_graduate: "ECO Alumni",
    graduated_students_statistic: "Alumni Statistics",
    employed_student: "Employed Students",
    counseling_center: "Counseling Center",
    pdc_student: "Students",
    cs: "Computer Science",
    eco: "Economy",
    email: "Email",
    phone: "Phone",
    job: "Job",
    startDate: "Start Date",
    endDate: "End Date",
    searchById: "Search by ID",
    search: "Search",
    search_open: "Open search",
    search_close: "Close search",
    search_clear: "Clear search",
    search_saba_university: "Search Saba University",
    search_page_title: "University Search",
    search_placeholder: "Search conferences, seminars, meetings, committees...",
    search_intro: "Search across university activities, academic events, and committees.",
    search_minimum_hint: "Type at least 2 characters to search.",
    searching: "Searching...",
    search_unavailable: "Search is temporarily unavailable. Please try again.",
    search_no_results: "No results found for",
    search_try_broader: "Try a broader keyword or another category.",
    search_all: "All",
    search_conferences: "Conferences",
    search_seminars: "Seminars",
    search_meetings: "Meetings / Discussions",
    search_committees: "Committees",
    search_filter_label: "Search categories",
    search_results: "Search results",
    search_results_for: "results for",
    search_view_all_results: "View all results",
    search_recent: "Recent searches",
    search_previous: "Previous",
    search_next: "Next",
    board: "Board",
    more: "More",
    student_services: "Student Services",
    policies_counsel: "Policies, Counsel",
    resourses: "Resourses",
    support_services: "Support Services",
    alumni_support_services: "Alumni & Support Services",
    enrollment_information: "Enrollment Information",
    guidance_general: "Guidance & General Info",
    guidelines: "Guidelines",
    institutions: "Institutions",
    find_out_more: "Find Out More",
    latest_posts: "Latest Posts",
    it_information: "IT Network refers to the design, implementation, and management of computer networks for data communication. It includes networking hardware, protocols, security, and troubleshooting to ensure efficient and secure connectivity.",
    se_information: "Software Engineering is the process of designing, developing, testing, and maintaining software applications using engineering principles. It focuses on creating reliable, scalable, and efficient software solutions to meet user and business needs.",
    is_information: "Information Systems focus on the collection, processing, storage, and distribution of information using technology. It integrates software, hardware, and data management to support decision-making and business operations efficiently.",
    neco_economics: "Studies the overall economic structure of a country, including production, consumption, trade, and government policies. It focuses on economic growth, inflation, employment, and fiscal management to ensure national stability and development.",
    beco_economics: "involves the management of financial transactions, including deposits, loans, investments, and payment processing. It plays a crucial role in economic growth by providing financial services to individuals, businesses, and governments.",
    baeco_economics: "involves planning, organizing, and managing business operations to achieve efficiency and growth. It covers areas such as finance, marketing, human resources, and strategic decision-making to ensure business success.",
    training_about_pdc: "Training & About PDC",
    explore_more: "Explore more",
    activities_explore: "Activities & Explore more",
    activities_resources: "Activities & Resources",
    quality_accreditation: "Quality Assurance & Accreditation",
    achievements_progress: "Achievements & Progress",
    enrollment_guidance: "Enrollment & Guidance",
    computer_science_alumni : "Computer Science Alumni",
    economic_alumni : "Economic Alumni",
    name: "Name",
    who_we_are: "Who We Are",
    latest_news: "Latest News",
    see_more	: "See More",
    lab	: "Lab",
    home_hero_label: "Saba University homepage hero",
    home_hero_eyebrow: "Official Saba University",
    home_hero_title: "Saba builds you, so that you can build your future!",
    home_hero_description: "Explore programs, admissions, student services, research, and the latest university updates in one clear place.",
    home_apply_now: "Apply Online",
    home_explore_programs: "Explore Programs",
    home_intro_eyebrow: "University Overview",
    home_intro_title: "A focused academic environment for Afghanistan's next professionals",
    home_intro_body: "Saba University provides student-centered higher education with academic quality, practical learning, and service to society.",
    home_stat_faculties: "Academic paths",
    home_stat_faculties_hint: "Computer Science, Economics, and professional development",
    home_stat_news: "University updates",
    home_stat_news_hint: "Published news and announcements",
    home_stat_research: "Research highlights",
    home_stat_research_hint: "Latest published academic work",
    home_value_quality_title: "Academic quality",
    home_value_quality_text: "Clear programs, quality assurance, and structured learning support.",
    home_value_practical_title: "Practical learning",
    home_value_practical_text: "Labs, research activity, seminars, and applied student experiences.",
    home_value_student_title: "Student support",
    home_value_student_text: "Admissions guidance, library resources, and student services.",
    home_programs_eyebrow: "Academic Programs",
    home_programs_title: "Choose a program with a clear academic path",
    home_programs_body: "Start with the main faculties and continue into detailed curriculum, labs, fees, calendar, and quality information.",
    home_program_cs_desc: "Computing, software, information systems, and applied digital skills.",
    home_program_eco_desc: "Economics, banking, business administration, and market-ready practice.",
    home_admission_eyebrow: "Admissions",
    home_admission_title: "Registration should be easy to find and easy to start",
    home_admission_body: "Prospective students can review requirements, open online registration, and check official Kankor results from the homepage.",
    home_registration_update: "Registration information",
    home_academic_event: "Academic event",
    home_empty_updates: "Admission updates will appear here when published.",
    home_news_eyebrow: "News and Announcements",
    home_news_title: "What is new at Saba University",
    home_news_body: "Recent public updates, announcements, and university activities from the official website.",
    home_empty_news: "Latest university news will appear here when published.",
    home_highlights_eyebrow: "Academic Life",
    home_highlights_title: "Research, achievements, and student activity",
    home_highlights_body: "A focused view of the academic work and activities that help students understand university life.",
    home_view_activities: "View Activities",
    home_empty_highlights: "Academic highlights will appear here when published.",
    home_quick_links_eyebrow: "Quick Access",
    home_quick_links_title: "Important student and visitor services",
    home_quick_links_body: "The most common actions are grouped here so students can move quickly to the right service.",
    home_apply_detail: "Start your registration",
    home_result_detail: "Search official results",
    home_library_detail: "Use academic resources",
    home_contact_detail: "Find location and support",
    home_contact_eyebrow: "Visit or Contact",
    home_contact_title: "Connect with Saba University",
    home_contact_body: "For admissions, academic programs, documents, or general support, use the official contact information.",
    loading: "Loading...",
    loading_data: "Loading data...",
    loading_website: "Loading website...",
    loading_navbar: "Loading navigation...",
    loading_footer: "Loading footer...",
    loading_page: "Loading page...",
    page_load_error_title: "This page could not load",
    page_load_error_message: "A website file did not load correctly. Please reload the page and try again.",
    reload_page: "Reload page",
    please_wait: "Please wait...",
    fetching_books: "Fetching books...",
    finding_results: "Finding results...",
    sending: "Sending...",
    send: "Send",
    sending_opinion: "Sending your opinion...",
    page_not_found: "Page not found",
    primary_navigation: "Primary navigation",
    language_selector: "Language selector",
    saba_university_home: "Saba University home",
    open_menu: "Open menu",
    close_menu: "Close menu",
    previous_image: "Previous image",
    next_image: "Next image",
    open_image_viewer: "Open image viewer",
    close_image_viewer: "Close image viewer",
    image_viewer: "Image viewer",
    gallery_navigation: "Gallery image navigation",
    gallery_thumbnails: "Gallery thumbnails",
    breadcrumb: "Breadcrumb",
    page_header: "Page header",
    media_gallery: "Saba University media gallery",
    no_gallery_image: "No gallery image available",
    gallery_image: "Saba University image",
    pagination: "Pagination",
    related_links: "Related links",
    date: "Date",
    download: "Download",
    book_name: "Book Name",
    book_image: "Book image",
    search_by: "Search By",
    search_by_required: "Search By *",
    search_by_book_id_or_name: "By ID, title or author",
    search_book: "Search Book",
    search_book_required: "Search Book *",
    search_book_placeholder: "Book ID, title or author *",
    library_search_hint: "Find books by ID, title or author.",
    all_inputs_required: "Please complete all required inputs.",
    library_search_type_invalid: "Please search by book ID, title or author.",
    login: "Login",
    student_password: "Student Password",
    student_password_required: "Student Password *",
    enter_id_required: "Enter ID *",
    enter_password_required: "Enter Password *",
    student_id_required_label: "Student ID *",
    student_documents_title: "Saba University Students Documents",
    student_id_required_message: "Student ID is required.",
    student_id_invalid_message: "Please enter a valid Student ID.",
    field_input_required: "input is required.",
    no_graduated_student_found: "There is no graduated student with this ID.",
    registration_form_title: "Fill the inputs for online admissions.",
    full_name_required: "Full Name *",
    name_required: "Name *",
    pashto_full_name_required: "Pashto Full Name *",
    pashto_name_required: "Pashto Name *",
    dari_full_name_required: "Dari Full Name *",
    dari_name_required: "Dari Name *",
    father_name_required: "Father Name *",
    father_name_placeholder: "F/Name *",
    pashto_father_name_required: "Pashto Father Name *",
    dari_father_name_required: "Dari Father Name *",
    graduation_year_required: "Graduation Year *",
    graduation_year_placeholder: "G/Year",
    high_school_name_required: "High School Name *",
    school_name_required: "School Name *",
    pashto_high_school_name_required: "Pashto High School Name *",
    pashto_school_name_required: "Pashto School Name *",
    dari_high_school_name_required: "Dari High School Name *",
    dari_school_name_required: "Dari School Name *",
    phone_number_required: "Phone Number *",
    phone_number_placeholder: "P/Number *",
    province_required: "Province *",
    pashto_province_required: "Pashto Province *",
    dari_province_required: "Dari Province *",
    email_address: "Email Address",
    register: "Register",
    registration_success: "Successfully registered.",
    submission_success: "Successfully submitted.",
    opinion_min_length: "Opinion must not be less than 30 characters.",
    read_more: "Read More",
    student_image: "Student Image",
    post_image: "Post image",
    member_image: "Member image",
    afghanistan_flag: "Afghanistan flag",
    united_states_flag: "United States flag",
    expiring_on: "Expiring on",
    contact_form_title: "Send a message to Saba University",
    contact_form_body: "For admissions, academic programs, documents, or general support, use the official contact form.",
    subject: "Subject",
    message: "Message",
    submit_message: "Submit Message",
    contact_information: "Contact Information",
    address: "Address",
    office_hours: "Office Hours",
    office_hours_value: "Saturday to Thursday, 05:00 AM - 08:00 PM",
    official_channels: "Official Channels",
    message_submitted_success: "Message submitted successfully.",
    required_suffix: "is required.",
    online_registration: "Online Registration",
    registration_date: "Registration Date",
    registration_shamsi_date: "Registration Date (Shamsi)",
    from_date: "From Date",
    to_date: "To Date",
    invalid_shamsi_date: "Invalid Shamsi/Jalali date.",
    no_registration_date: "No registration date",
    online_registration_subtitle: "Choose your graduation type, then complete the official Saba University A4 registration form.",
    choose_application_type: "Choose Application Type",
    registration_step_type: "Graduation Type",
    registration_step_faculty: "Faculty",
    registration_step_form: "Official Form",
    registration_step_card: "Entry Card",
    choose_faculty: "Choose Faculty",
    select_faculty: "Select Faculty",
    faculty_required: "Please select a faculty before opening the official form.",
    no_faculties_available: "No faculties are currently enabled for online registration.",
    change_faculty: "Change Faculty",
    registration_faculty_hint: "Only faculties enabled by the administration are available for online registration.",
    registration_form_locked_until_faculty: "Select an active faculty to open the official registration form.",
    grade_12_application: "High School Graduate - Grade 12",
    grade_14_application: "Grade 14 / Semi-Higher Education Graduate",
    master_application: "MBA / Master's Program",
    choose_program: "Choose Program",
    selected_program: "Program",
    master_registration_notice: "Master's program availability is set by the Admissions Office.",
    master_registration_closed: "Master's registration is currently closed.",
    registration_confirmation: "Confirmation",
    registration_required: "Required",
    registration_optional: "Optional",
    registration_invalid_value: "Please check the value for {field}.",
    registration_admin_assigned: "Assigned by Administration",
    loading_online_registration: "Loading online registration...",
    online_registration_unavailable: "Online registration is unavailable right now.",
    registration_closed: "Registration Closed",
    change_type: "Change Type",
    submit_official_form: "Submit Form",
    update_previous_submission: "Replace / Update Previous Submission",
    submitting: "Submitting...",
    print_form: "Print Form",
    download_pdf: "Download PDF",
    registration_submitted: "Registration Successfully Submitted",
    registration_submitted_copy: "Your registration form has been successfully submitted and saved.",
    registration_updated: "Registration Successfully Updated",
    registration_updated_copy: "Your registration information was successfully updated and saved.",
    kankor_entry_card: "Official Kankor Entry Card",
    kankor_entry_card_copy: "This card is generated from your submitted registration record. Print it after the administration confirms the exam date and Student ID if required.",
    fix_required_fields: "Please complete the highlighted fields on the official form before submitting.",
    duplicate_registration_warning: "An existing registration was found. Continuing will replace/update your previous submitted information.",
    duplicate_confirmation: "I understand and want to replace/update my previous submitted information.",
    photo_required: "Student photo is required.",
    identity_document_required: "Please provide an electronic Tazkira, passport, or paper Tazkira registration/general number.",
    official_form_timeout: "The official form did not respond. Please reload the page and try again.",
    valid_email_required: "Please enter a valid email address.",
    official_form_ready: "Official form ready",
    loading_official_form: "Loading official form...",
    submitted: "Submitted",
    footer_about_text: "Saba University provides organized higher education, student services, research activity, and community-focused academic programs.",
    footer_links_title: "Important Links",
    footer_copyright: "Copyright",

  },
  ps:{
    ...institutionalPages.ps,
    ...masterPrograms.ps,
    textDirection: "rtl",
    home: "کور پاڼه",
    // home: "اصلی صفحه",
    // About
    about: "زموږ په اړه",
      vission_mission:"لرلید او رسالت",
      our_vission_and_mission:"لرلید او رسالت",
      chancellor_message: "د رئیس پیغام",
      organizational_structure: "اداري جوړښت",
      stratigic_aim: "ستراتیژیکې موخې",
      academic_calendar: "علمي تقویم",
      aggrements: "هوکړه لیکونه",
      aggrement: "هوکړه لیکونه",

    a_pdc: "مسلکي پرمختیایي مرکز",
      a_pdc_b: "مسلکي پرمختیایی بورډ",
    // Academic
    academics_programs: "علمي پروګرامونه",
      academics: "علمي",
      a_quality_assurance: "تضمین کیفیت",
        a_aims: "اهداف",
        a_self_assesment: "ځان ارزونې اصلي او فرعي معیارونه",
        a_annual_program_monitoring: "کلنی څارنه",
        a_councils_committees: "کمېټې او شوراګانې",
        a_manual_policies: "پالیسیانې او طرزالعملونه",
        a_capacity_building: "ورکشاپونه او سمیینارونه",
        accreditation: "اعتبار اخیستنه",
      a_bcs_computer_science: "کمپیوټرساینس",
      a_bba_economics: "اقتصاد",
        a_vission_mission: "لرلید رسالت او موخې",
        a_curriculum: "نصاب",
        a_organizational_structure: "اداري جوړښت",
        a_aggrements: "هوکړه لیکونه",


    // Rechearch
    research: "څیړنی",
    quality: "Quality",
      capacity_building: "ورکشاپونه او سمیینارونه",
      r_vission_mission: "لرلید، رسالت او موخې",
      manual_policies: "پالیسیانې او طرزالعملونه",
      saba_magazine: "سبا څېړنیزه مجله",
      research_publications: "نشر سوې څېړنې",

    // Students
    pdc_student: "محصلان",
    student: "محصلان",
      eligibility_criteria: "د داخلې شرائط",
      scholarships_financing: "د محصلانو مالي تمویل او تشویق",
      migration_policy: "تبدیلي",
      semester_promotion_rules: "د سمیستر ناکامي",
      penalties: "د ډسپلین خلاف کړنې او مجازات",


    saba_library: "سبا کتابتون",
    news: "خبرونه",
    contact: "اړیکه",
    job_opportunity: "کاري فرصت",

    // Kankor
    kankor: "کانکور",
      online_admission: "آنلاین نوملیکنه",
      result: "نتیجه",
      kankor_results: "د کانکور پایلې",
      kankor_result_portal: "د پایلو رسمي پورټل",
      saba_university: "سبا پوهنتون",
      student_id: "د محصل آی ډي",
      student_name: "د محصل نوم",
      father_name: "د پلار نوم",
      grandfather_name: "د نیکه نوم",
      selected_faculty: "ټاکل شوی پوهنځی",
      kankor_marks: "د کانکور نمرې",
      result_status: "د پایلې حالت",
      student_type: "\u062f \u0645\u062d\u0635\u0644 \u0689\u0648\u0644",
      kankor_status_pass: "\u0628\u0631\u06cc\u0627\u0644\u06cc",
      kankor_status_fail: "\u0646\u0627\u06a9\u0627\u0645",
      grade_12: "\u062f \u062f\u0648\u0644\u0633\u0645 \u067c\u0648\u0644\u06ab\u064a",
      grade_14: "\u062f \u0685\u0648\u0627\u0631\u0644\u0633\u0645 \u067c\u0648\u0644\u06ab\u064a",
      maximum_marks: "\u0627\u0639\u0638\u0645\u064a \u0646\u0645\u0631\u06d0",
      passing_score: "\u062f \u0628\u0631\u06cc\u0627 \u062d\u062f",
      invalid_marks: "\u0646\u0627\u0633\u0645\u06d0 \u0646\u0645\u0631\u06d0",
      marks_cannot_exceed: "\u0646\u0645\u0631\u06d0 \u0644\u0647 \u067c\u0627\u06a9\u0644\u064a \u062d\u062f \u0685\u062e\u0647 \u0646\u0647 \u0634\u064a \u0632\u06cc\u0627\u062a\u06d0\u062f\u0627\u06cc.",
      student_photo: "د محصل انځور",
      enter_student_id: "خپل د محصل آی ډي ولیکئ",
      kankor_student_id_required: "مهرباني وکړئ خپل د محصل آی ډي ولیکئ.",
      kankor_student_id_invalid: "مهرباني وکړئ سم د محصل آی ډي ولیکئ.",
      kankor_result_not_found: "د دې محصل آی ډي لپاره پایله ونه موندل شوه.",
      kankor_result_lookup_error: "د پایلې لټون لنډمهاله شتون نه لري. بیا هڅه وکړئ.",
      kankor_result_share_description: "د سبا پوهنتون دا رسمي عامه د کانکور پایله وګورئ.",
      kankor_result_search_hint: "د محصل آی ډي په وسیله خپله رسمي پایله په خصوصي ډول وګورئ.",
      kankor_share_copied: "د شریکولو لینک کاپي شو.",
      kankor_share_copy_failed: "کاپي ونه شوه. مهرباني وکړئ لینک په لاسي ډول کاپي کړئ.",
      kankor_share_ready: "د پایلې لینک شریکولو ته چمتو دی.",
      kankor_result_not_found_title: "پایله ونه موندل شوه",
      kankor_result_not_found_detail: "کېدای شي شریکه شوې پایله لرې شوې وي یا لینک نور اعتبار ونه لري.",
      kankor_result_public_card: "عامه د پایلې کارت",
      kankor_result_verified: "تایید شوی عامه ریکارډ",
      official: "رسمي",
      result_public_id: "د عامه پایلې آی ډي",
      share_result: "پایله شریکه کړئ",
      share_result_hint: "دا خوندي عامه لینک ملګرو یا کورنۍ ته واستوئ.",
      share_result_link: "د پایلې د شریکولو لینک",
      copy_link: "لینک کاپي کړئ",
      print_result: "چاپ / د PDF په توګه خوندي کړئ",
      share: "شریکول",

    saba_economical_board: "سبا اقتصادي بورډ",
    seb: "سبا اقتصادي بورډ",
    nothing_to_show: "تر اوسه د ښودلو لپاره هیڅ شی نشته",
    posts: "پوسټونه",
    post: "پوسټ",
    chancellor_of_saba: "د سبا پوهنتون رییس",
    achievements: "لاسته راوړنې",
    annual_two_semesters: "کلني دوه سمسترونه",
    author: "لیکوال",
    page: "ګڼه",
    a_about: "موخی",
    related: "اړوند",
    document: "سند",
    fullName: "بشپړ نوم",
    fatherName: "د پلار نوم",
    faculty: "پوهنځی",
    faculties: "لیسانس",
    id: "آیډی",
    yourDocuments: "ستاسو اسناد",
    logOut: "وتل",
    graduated_date: "د فراغت نیټه",
    menu: "مینیو",
    saba_foundation: "سبا مرستندویه بنیاد",
    foundation: "سبا مرستندویه بنیاد",
    structure: "جوړښت",
    vission: "لرلید",
    mission: "رسالت",
    values: "ارزښتونه",
    years_plane: "پنځه کلن ستراتیژیک پلان",
    strategic_plane: "ستراتیژیک پلان",
    strategic_aims: "ستراتیژیکی موخی",
    downloadPlanFile: "فایل ډاونلوډ کړی",
    councils_and_committees: "شوراګانی او کمیټی",
    academic_programs: "علمی برنامی",
    your_opinion: "ستاسو نظر",
    write_opinion: "موږ ته دی نظر ولیکه",
    informational_technology: "معلوماتي ټکنالوژي",
    it: "معلوماتي ټکنالوژي",
    curriculum: "نصاب",
    labs: "لیبونه",
    library: "کتابتون",
    libraryinfos: "د کتابتون معلومات",
    semester_fee: "سمسټر فیس",
    software_engineering: "سافټویر انجینري",
    se: "سافټویر انجینري",
    information_system: "معلوماتي سیسټمونه",
    is: "معلوماتي سیسټمونه",
    national_economics: "ملی اقتصاد",
    neco: "ملی اقتصاد",
    banking: "بانکداري",
    beco: "بانکداري",
    business_administration: "اداره او تجارت",
    baeco: "اداره او تجارت",
    research_trainings: "څیړنیزه روزنه",
    training_about_pdc: "روزنه او د PDC په اړه",
    research_support: "څیړنیز ملاتړ",
    policies_and_procedures : "پالیسیاني او طرزالعملونه",
    research_papers_and_publication: "څیړنیز اثار او انتشارات",
    research_papers_and_publications: "څیړنیز اثار او انتشارات",
    scientific_and_research_magazine: "علمي او څیړنیزه مجله",
    research_paper: "څیړنیزي مقالي",
    research_guide: "د څیړني لارښود",
    research_activities: "څیړنیزي کړني",
    activities: "کړني",
    planed_researche : "پلان سوي څیړني",
    under_process_researche: "تر کار لاندي څیړني",
    completed_researche: "تکمیل سوي څیړني",
    published_researche: "نشر سوي څیړني",
    publishedresearches: "نشر سوي څیړني",
    annual_professional_development_plan: "کلنی مسلکي پرمختیایی پلان",
    seminars_courses_workshop: "سیمینارونه ورکشاپونه کورسونه ",
    teacher: "استادان",
    administrative_staff: "اداري او خدماتی کارمندان",
    society: "ټولنه",
    periodic_program_review: "دورئی بیاکتنه",
    internal_accreditation: "داخلی اعتبار اخیستنه",
    national_accreditation: "ملي اعتبار اخیستنه",
    international_accreditation: "بین المللی اعتبار اخیستنه",
    offline_enrollment_requirement: "د حضوري نوم لیکني شرایط",
    kankor_guide: "د کانکور لارښود",
    kankor_registration_date : "د کانکور د نوم لیکني نیټه",
    enrolled : "اختصاصي",
    general: "عمومي",
    activity: "فعالیتونه",
    online_library : "انلاین کتابتون",
    digital_library: "ډیجیټل کتابتونه",
    offline_library : "حضوري کتابتونه",
    procedure: "طرزالعمل",
    study_statistic: "مطالعه کوونکو احصائیه",
    progressive_plan:"انکشافي پلان",
    students_engagement:"د محصلانو بوختیا",
    students_experience: "د محصلانو تجارب",
    tours_of_student: "د محصلانو علمي سیرونه",
    students_statistic: "د محصلانو احصائیه",
    statistics:"احصائیه",
    statistic:"احصائیه",
    tajil : "تاجیل",
    deprived: "محروم",
    chance: "چانس",
    re_enrollment: "بیاشمولیت",
    eresticate: "منفک",
    transformation: "تبدیلی",
    repeat: "ریپیټ",
    graduate: "فارغان",
    cs_graduate: "فارغان",
    eco_graduate: "فارغان",
    graduated_students_statistic: "دفارغ  محصلانو احصائیه",
    employed_student: "پرکار ګمارل سوي",
    counseling_center: "مشورتي مرکز",
    cs: "کمپیوټرساینس",
    eco: "اقتصاد",
    email: "ایمیل",
    phone: "شمیره",
    job: "دنده",
    startDate: "شروع نیټه",
    endDate: "ختم نیټه",
    searchById: "Search by ID",
    search: "لټون",
    search_open: "لټون پرانیزئ",
    search_close: "لټون بند کړئ",
    search_clear: "لټون پاک کړئ",
    search_saba_university: "د سبا پوهنتون لټون",
    search_page_title: "د پوهنتون لټون",
    search_placeholder: "کنفرانسونه، سیمینارونه، غونډې او کمېټې ولټوئ...",
    search_intro: "د پوهنتون فعالیتونه، علمي پروګرامونه او کمېټې ولټوئ.",
    search_minimum_hint: "د لټون لپاره لږ تر لږه ۲ توري ولیکئ.",
    searching: "لټون روان دی...",
    search_unavailable: "لټون لنډمهاله شتون نه لري. بیا هڅه وکړئ.",
    search_no_results: "هېڅ پایله ونه موندل شوه د",
    search_try_broader: "پراخه کلیمه یا بله کټګوري وازموئ.",
    search_all: "ټول",
    search_conferences: "کنفرانسونه",
    search_seminars: "سیمینارونه",
    search_meetings: "غونډې / بحثونه",
    search_committees: "کمېټې",
    search_filter_label: "د لټون کټګورۍ",
    search_results: "د لټون پایلې",
    search_results_for: "پایلې د",
    search_view_all_results: "ټولې پایلې وګورئ",
    search_recent: "وروستي لټونونه",
    search_previous: "مخکینی",
    search_next: "بل",
    board: "بورډ",
    more: "نور",
    student_services: "محصلانو خدمتونه",
    policies_counsel: "تګلارې او مشورې",
    resourses: "منابع",
    support_services: "ملاتړی خدمتونه",
    enrollment_information: "د شمولیت معلومات",
    guidance_general: "لارښوونه او عمومي معلومات",
    guidelines: "لارښودنې",
    institutions: "ادارې",
    latest_posts: "وروستي پوسټونه",
    find_out_more: "نور معلومات ترلاسه کړئ",
    it_information: "د معلوماتي ټکنالوژۍ شبکه د کمپیوټر شبکو ډیزاین، پلي کولو، او مدیریت ته اشاره کوي ترڅو د معلوماتو اړیکې یقیني کړي. دا د شبکې هارډویر، پروتوکولونه، امنیت، او د ستونزو حل شاملوي ترڅو خوندي او اغیزمن اتصال تضمین کړي.",
    se_information: "د سافټویر انجنیرۍ د سافټویر غوښتنلیکونو د ډیزاین، پراختیا، ازموینې، او ساتنې پروسه ده چې د انجنیرۍ اصولو پراساس ترسره کیږي. دا د باوري، پراخېدونکي، او مؤثره سافټویر حلونو رامینځته کولو تمرکز لري ترڅو د کاروونکو او سوداګریزو اړتیاوو پوره کولو کې مرسته وکړي.",
    is_information: "د معلوماتي سیستمونه د معلوماتو راټولولو، پروسس کولو، ذخیره کولو، او ویشلو تمرکز لري چې د ټیکنالوژۍ له لارې ترسره کیږي. دا د سافټویر، هارډویر، او معلوماتو مدیریت سره یوځای کیږي ترڅو د تصمیم نیولو او سوداګریزو عملیاتو ملاتړ وکړي.",
    neco_economics: "ملي اقتصاد د یو هېواد ټولیز اقتصادي جوړښت مطالعه کوي، چې پکې تولید، مصرف، سوداګري، او دولتي پالیسۍ شاملې دي. دا د اقتصادي وده، انفلاسیون، استخدام، او مالي مدیریت تمرکز لري ترڅو د ملي ثبات او پرمختګ یقیني کړي.",
    beco_economics: "بانکداري د مالي معاملو مدیریت ته اشاره کوي، چې پکې سپما، پورونه، پانګونه، او د تادیاتو پروسس شامل دي. دا د مالي خدماتو په برابرولو سره د افرادو، سوداګریو، او حکومتونو لپاره د اقتصادي ودې مهم رول لوبوي.",
    baeco_economics: "د سوداګرۍ اداره د سوداګریزو عملیاتو د پلان جوړولو، تنظیم، او مدیریت پروسه ده ترڅو موثریت او وده ترلاسه کړي. دا د مالي چارو، بازار موندنې، بشري سرچینو، او ستراتیژیکو پرېکړو برخې پوښي ترڅو د سوداګرۍ بریا یقیني کړي.",
    explore_more: " نور وپلټئ",
    activities_explore: "فعالیتونه او نور وپلټئ",
    activities_resources: " فعالیتونه او منابع",
    quality_accreditation: "تضمین کیفیت او اعتبار اخیستنه",
    achievements_progress: "پرمختګ او لاسته راوړنې",
    enrollment_guidance: "شمولیت او نوری لارښوونی",
    no_posts: "پوسټونه نشته چې وښودل شي",
    research_quality: "څیړنه او کیفیت",
    alumni_support_services: "فاریغین او د ملاتړ خدمتونه",
    computer_science_alumni : "د کمپیوټر ساینس فاریغان",
    economic_alumni : "د اقتصا فاریغان",
    name: "نوم",
    who_we_are: "موږ څوک یو",
    latest_news: "وروستی خبرونه",
    see_more	: "نور وګورئ",
    lab	: "لیب",
    home_hero_label: "د سبا پوهنتون د کورپاڼې هیرو برخه",
    home_hero_eyebrow: "سبا پوهنتون",
    home_hero_title: "سبا تاسو جوړوي، ترڅو تاسو خپل راتلونکی جوړ کړئ!",
    home_hero_description: "علمي پروګرامونه، داخله، محصل خدمتونه، څېړنه او د پوهنتون وروستي خبرونه په یوه روښانه ځای کې وګورئ.",
    home_apply_now: "آنلاین نوم لیکنه",
    home_explore_programs: "پروګرامونه وګورئ",
    home_intro_eyebrow: "د پوهنتون لنډه پېژندنه",
    home_intro_title: "د افغانستان د راتلونکو مسلکي کسانو لپاره متمرکز علمي چاپېریال",
    home_intro_body: "سبا پوهنتون د محصل پر محور لوړې زده کړې، علمي کیفیت، عملي زده کړه او ټولنې ته خدمت وړاندې کوي.",
    home_stat_faculties: "علمي لارې",
    home_stat_faculties_hint: "کمپیوټر ساینس، اقتصاد او مسلکي پرمختګ",
    home_stat_news: "د پوهنتون تازه معلومات",
    home_stat_news_hint: "خپاره شوي خبرونه او اعلانونه",
    home_stat_research: "څېړنیز ټکي",
    home_stat_research_hint: "وروستي خپاره شوي علمي آثار",
    home_value_quality_title: "علمي کیفیت",
    home_value_quality_text: "روښانه پروګرامونه، د کیفیت تضمین او منظم علمي ملاتړ.",
    home_value_practical_title: "عملي زده کړه",
    home_value_practical_text: "لابراتوارونه، څېړنیزې کړنې، سیمینارونه او عملي محصلي تجربې.",
    home_value_student_title: "د محصل ملاتړ",
    home_value_student_text: "د داخلې لارښوونه، کتابتون او د محصل خدمتونه.",
    home_programs_eyebrow: "علمي پروګرامونه",
    home_programs_title: "د روښانه علمي مسیر لرونکی پروګرام وټاکئ",
    home_programs_body: "له اصلي پوهنځیو پیل وکړئ او نصاب، لابراتوارونه، فیس، تقویم او کیفیت معلومات وګورئ.",
    home_program_cs_desc: "کمپیوټر، سافټویر، معلوماتي سیستمونه او عملي ډیجیټل مهارتونه.",
    home_program_eco_desc: "اقتصاد، بانکداري، اداره او سوداګري، او د بازار لپاره عملي چمتووالی.",
    home_admission_eyebrow: "داخله",
    home_admission_title: "نوم لیکنه باید اسانه پیدا او اسانه پیل شي",
    home_admission_body: "راتلونکي محصلان کولی شي شرایط وګوري، آنلاین نوم لیکنه پرانیزي او د کانکور رسمي پایلې له کورپاڼې وګوري.",
    home_registration_update: "د نوم لیکنې معلومات",
    home_academic_event: "علمي پروګرام",
    home_empty_updates: "د داخلې تازه معلومات به د خپرېدو وروسته دلته ښکاره شي.",
    home_news_eyebrow: "خبرونه او اعلانونه",
    home_news_title: "په سبا پوهنتون کې څه نوي دي",
    home_news_body: "د رسمي وېبپاڼې وروستي عامه خبرونه، اعلانونه او پوهنتوني فعالیتونه.",
    home_empty_news: "د پوهنتون وروستي خبرونه به د خپرېدو وروسته دلته ښکاره شي.",
    home_highlights_eyebrow: "علمي ژوند",
    home_highlights_title: "څېړنه، لاسته راوړنې او محصلي فعالیتونه",
    home_highlights_body: "د علمي کارونو او فعالیتونو متمرکز لید چې محصلان د پوهنتون ژوند ښه درک کړي.",
    home_view_activities: "فعالیتونه وګورئ",
    home_empty_highlights: "علمي ټکي به د خپرېدو وروسته دلته ښکاره شي.",
    home_quick_links_eyebrow: "چټک لاسرسی",
    home_quick_links_title: "د محصلانو او لیدونکو مهم خدمتونه",
    home_quick_links_body: "عام کارونه دلته راټول شوي ترڅو محصلان ژر مناسب خدمت ته ولاړ شي.",
    home_apply_detail: "خپله نوم لیکنه پیل کړئ",
    home_result_detail: "رسمي پایلې ولټوئ",
    home_library_detail: "علمي سرچینې وکاروئ",
    home_contact_detail: "ادرس او ملاتړ ومومئ",
    home_contact_eyebrow: "لیدنه یا اړیکه",
    home_contact_title: "له سبا پوهنتون سره اړیکه ونیسئ",
    home_contact_body: "د داخلې، علمي پروګرامونو، اسنادو یا عمومي ملاتړ لپاره رسمي اړیکې وکاروئ.",
    loading: "د پورته کېدو په حال کې...",
    loading_data: "معلومات پورته کېږي...",
    loading_website: "وېب‌سایټ پورته کېږي...",
    loading_navbar: "لارښود پورته کېږي...",
    loading_footer: "فوټر پورته کېږي...",
    loading_page: "پاڼه پورته کېږي...",
    page_load_error_title: "دا پاڼه پورته نه شوه",
    page_load_error_message: "د وېب‌سایټ یوه برخه په سم ډول پورته نه شوه. مهرباني وکړئ پاڼه بیا پورته کړئ.",
    reload_page: "پاڼه بیا پورته کړئ",
    please_wait: "مهرباني وکړئ انتظار وکړئ...",
    fetching_books: "کتابونه راوړل کېږي...",
    finding_results: "پایلې لټول کېږي...",
    sending: "لېږل کېږي...",
    send: "لېږل",
    sending_opinion: "ستاسې نظر لېږل کېږي...",
    page_not_found: "پاڼه ونه موندل شوه",
    primary_navigation: "اصلي لارښود",
    language_selector: "د ژبې ټاکنه",
    saba_university_home: "د سبا پوهنتون کورپاڼه",
    open_menu: "مینو پرانیزئ",
    close_menu: "مینو وتړئ",
    previous_image: "مخکینی انځور",
    next_image: "بل انځور",
    open_image_viewer: "د انځور لیدونکی پرانیزئ",
    close_image_viewer: "د انځور لیدونکی وتړئ",
    image_viewer: "د انځور لیدونکی",
    gallery_navigation: "د ګالري انځورونو لارښود",
    gallery_thumbnails: "د ګالري کوچني انځورونه",
    breadcrumb: "د لارښود مسیر",
    page_header: "د پاڼې سرلیک",
    media_gallery: "د سبا پوهنتون رسنیزه ګالري",
    no_gallery_image: "د ګالري انځور نشته",
    gallery_image: "د سبا پوهنتون انځور",
    pagination: "مخپاڼې",
    related_links: "اړوند لینکونه",
    date: "نېټه",
    download: "ډاونلوډ",
    book_name: "د کتاب نوم",
    book_image: "د کتاب انځور",
    search_by: "لټون پر بنسټ",
    search_by_required: "د لټون ډول *",
    search_by_book_id_or_name: "د آی ډي، نوم یا لیکوال له مخې",
    search_book: "کتاب ولټوئ",
    search_book_required: "کتاب ولټوئ *",
    search_book_placeholder: "د کتاب آی ډي، نوم یا لیکوال *",
    library_search_hint: "کتابونه د آی ډي، نوم یا لیکوال له مخې ولټوئ.",
    all_inputs_required: "مهرباني وکړئ ټول اړین معلومات بشپړ کړئ.",
    library_search_type_invalid: "مهرباني وکړئ د کتاب آی ډي، نوم یا لیکوال له مخې لټون وکړئ.",
    login: "ننوتل",
    student_password: "د محصل پټنوم",
    student_password_required: "د محصل پټنوم *",
    enter_id_required: "آی ډي ولیکئ *",
    enter_password_required: "پټنوم ولیکئ *",
    student_id_required_label: "د محصل آی ډي *",
    student_documents_title: "د سبا پوهنتون د محصلانو اسناد",
    student_id_required_message: "د محصل آی ډي اړین دی.",
    student_id_invalid_message: "مهرباني وکړئ سم د محصل آی ډي ولیکئ.",
    field_input_required: "ډګر اړین دی.",
    no_graduated_student_found: "په دې آی ډي فارغ محصل ونه موندل شو.",
    registration_form_title: "د آنلاین داخلې لپاره معلومات بشپړ کړئ.",
    full_name_required: "بشپړ نوم *",
    name_required: "نوم *",
    pashto_full_name_required: "پښتو بشپړ نوم *",
    pashto_name_required: "پښتو نوم *",
    dari_full_name_required: "دري بشپړ نوم *",
    dari_name_required: "دري نوم *",
    father_name_required: "د پلار نوم *",
    father_name_placeholder: "د پلار نوم *",
    pashto_father_name_required: "د پلار پښتو نوم *",
    dari_father_name_required: "د پلار دري نوم *",
    graduation_year_required: "د فراغت کال *",
    graduation_year_placeholder: "د فراغت کال",
    high_school_name_required: "د ښوونځي نوم *",
    school_name_required: "د ښوونځي نوم *",
    pashto_high_school_name_required: "د ښوونځي پښتو نوم *",
    pashto_school_name_required: "د ښوونځي پښتو نوم *",
    dari_high_school_name_required: "د ښوونځي دري نوم *",
    dari_school_name_required: "د ښوونځي دري نوم *",
    phone_number_required: "د ټلیفون شمېره *",
    phone_number_placeholder: "د ټلیفون شمېره *",
    province_required: "ولایت *",
    pashto_province_required: "پښتو ولایت *",
    dari_province_required: "دري ولایت *",
    email_address: "ایمیل آدرس",
    register: "ثبتول",
    registration_success: "ثبت نام په بریالیتوب ترسره شو.",
    submission_success: "په بریالیتوب واستول شو.",
    opinion_min_length: "نظر باید له ۳۰ تورو کم نه وي.",
    read_more: "نور ولولئ",
    student_image: "د محصل انځور",
    post_image: "د پوسټ انځور",
    member_image: "د غړي انځور",
    afghanistan_flag: "د افغانستان بیرغ",
    united_states_flag: "د امریکا بیرغ",
    expiring_on: "د ختمېدو نېټه",
    contact_form_title: "له سبا پوهنتون سره اړیکه ونیسئ",
    contact_form_body: "د داخلې، علمي پروګرامونو، اسنادو یا عمومي ملاتړ لپاره رسمي د اړیکې فورم وکاروئ.",
    subject: "موضوع",
    message: "پیغام",
    submit_message: "پیغام ولېږئ",
    contact_information: "د اړیکې معلومات",
    address: "پته",
    office_hours: "د دفتر وختونه",
    office_hours_value: "شنبه تر پنجشنبې، 05:00 سهار - 08:00 ماښام",
    official_channels: "رسمي چینلونه",
    message_submitted_success: "پیغام په بریالیتوب واستول شو.",
    required_suffix: "اړین دی.",
    online_registration: "آنلاین ثبت نام",
    registration_date: "د ثبت نېټه",
    registration_shamsi_date: "د ثبت نېټه (شمسي)",
    from_date: "له نېټې",
    to_date: "تر نېټې",
    invalid_shamsi_date: "ناسمه شمسي/جلالي نېټه.",
    no_registration_date: "د ثبت نېټه نشته",
    online_registration_subtitle: "د فراغت ډول وټاکئ، بیا د سبا پوهنتون رسمي A4 ثبت نام فورم بشپړ کړئ.",
    choose_application_type: "د غوښتنلیک ډول وټاکئ",
    registration_step_type: "د فراغت ډول",
    registration_step_faculty: "پوهنځی",
    registration_step_form: "رسمي فورم",
    registration_step_card: "د ګډون کارت",
    choose_faculty: "پوهنځی وټاکئ",
    select_faculty: "پوهنځی انتخاب کړئ",
    faculty_required: "مهرباني وکړئ د رسمي فورم له پرانیستلو مخکې پوهنځی وټاکئ.",
    no_faculties_available: "اوس مهال د آنلاین ثبت نام لپاره فعال پوهنځی نشته.",
    change_faculty: "پوهنځی بدل کړئ",
    registration_faculty_hint: "یوازې هغه پوهنځي ښکاري چې ادارې د آنلاین ثبت نام لپاره فعال کړي دي.",
    registration_form_locked_until_faculty: "د رسمي ثبت نام فورم د پرانیستلو لپاره فعال پوهنځی وټاکئ.",
    grade_12_application: "د دولسم ټولګي فارغ",
    grade_14_application: "د څوارلسم ټولګي / نیمه عالي زده کړو فارغ",
    master_application: "د سوداګرۍ مدیریت ماستري / MBA",
    choose_program: "پروګرام غوره کړئ",
    selected_program: "پروګرام",
    master_registration_notice: "د ماسترۍ پروګرام شتون د نوم‌لیکنې ادارې لخوا ټاکل کېږي.",
    master_registration_closed: "د ماسترۍ نوم‌لیکنه اوس مهال تړلې ده.",
    registration_confirmation: "تایید",
    registration_required: "اړین",
    registration_optional: "اختیاري",
    registration_invalid_value: "مهرباني وکړئ د {field} معلومات سم کړئ.",
    registration_admin_assigned: "د ادارې لخوا ټاکل کېږي",
    loading_online_registration: "آنلاین ثبت نام پورته کېږي...",
    online_registration_unavailable: "آنلاین ثبت نام اوس مهال شتون نه لري.",
    registration_closed: "ثبت نام تړل شوی",
    change_type: "ډول بدل کړئ",
    submit_official_form: "فورم وسپارئ",
    update_previous_submission: "پخوانی غوښتنلیک بدل/تازه کړئ",
    submitting: "سپارل کېږي...",
    print_form: "فورم چاپ کړئ",
    download_pdf: "PDF ډاونلوډ کړئ",
    registration_submitted: "ستاسو نوم‌لیکنه په بریالیتوب سره ترسره شوه",
    registration_submitted_copy: "ستاسو فورم په بریالیتوب سره ثبت او خوندي شو.",
    registration_updated: "ستاسو نوم‌لیکنه په بریالیتوب سره تازه شوه",
    registration_updated_copy: "ستاسو د نوم‌لیکنې معلومات په بریالیتوب سره تازه او خوندي شول.",
    kankor_entry_card: "د کانکور رسمي د ګډون کارت",
    kankor_entry_card_copy: "دا کارت ستاسې له سپارل شوي ثبت نام څخه جوړیږي. که اړتیا وي، د ازموینې نېټې او آی ډي له تایید وروسته یې چاپ کړئ.",
    fix_required_fields: "مهرباني وکړئ د سپارلو مخکې په رسمي فورم کې روښانه شوي ډګرونه بشپړ کړئ.",
    duplicate_registration_warning: "موجود ثبت نام وموندل شو. دوام ورکول به ستاسې پخواني سپارل شوي معلومات بدل/تازه کړي.",
    duplicate_confirmation: "زه پوهېږم او غواړم خپل پخواني سپارل شوي معلومات بدل/تازه کړم.",
    photo_required: "د محصل عکس اړین دی.",
    identity_document_required: "مهرباني وکړئ برېښنایي تذکره، پاسپورټ، یا د کاغذي تذکرې د ثبت/عمومي نمبر ورکړئ.",
    official_form_timeout: "رسمي فورم ځواب ورنه کړ. مهرباني وکړئ پاڼه بیا پورته کړئ او بیا هڅه وکړئ.",
    valid_email_required: "مهرباني وکړئ سم ایمیل آدرس ولیکئ.",
    official_form_ready: "رسمي فورم چمتو دی",
    loading_official_form: "رسمي فورم پورته کېږي...",
    submitted: "سپارل شوی",
    footer_about_text: "سبا پوهنتون منظمې لوړې زده کړې، محصل خدمتونه، څېړنیز فعالیتونه او ټولنې ته ګټور علمي پروګرامونه وړاندې کوي.",
    footer_links_title: "مهم لینکونه",
    footer_copyright: "د چاپ حق",


  },
  fa:{
    ...institutionalPages.fa,
    ...masterPrograms.fa,
    textDirection: "rtl",
    home: "صفحه اصلی",
    contact: "تماس",
    about: "درباره ما",
      vission_mission: "چشم‌انداز و ماموریت",
      our_vission_and_mission: "چشم‌انداز و ماموریت",
      chancellor_message: "پیام رئیس پوهنتون",
      organizational_structure: "تشکیلات اداری",
      stratigic_aim: "اهداف استراتژیک",
      academic_calendar: "تقویم علمی",
      aggrements: "تفاهم‌نامه‌ها",
      aggrement: "تفاهم‌نامه‌ها",

    a_pdc: "انکشاف مسلکی",
      a_pdc_b: "بورد انکشاف مسلکی",

    academics_programs: "برنامه‌های علمی",
      academics: "علمی",
      a_quality_assurance: "تضمین کیفیت",
        a_aims: "اهداف",
        a_self_assesment: "خودارزیابی",
        a_annual_program_monitoring: "نظارت سالانه برنامه",
        a_councils_committees: "شوراها و کمیته‌ها",
        a_manual_policies: "رهنمودها و پالیسی‌ها",
        a_capacity_building: "ارتقای ظرفیت",
        accreditation: "اعتباردهی",
      a_bcs_computer_science: "کمپیوتر ساینس",
      a_bba_economics: "اقتصاد",
        a_vission_mission: "چشم‌انداز، ماموریت و درباره",
        a_curriculum: "نصاب تحصیلی",
        a_organizational_structure: "تشکیلات اداری",
        a_aggrements: "تفاهم‌نامه‌ها",

    research: "تحقیق",
      quality: "کیفیت",
      research_quality: "تحقیق و کیفیت",
      capacity_building: "ارتقای ظرفیت",
      r_vission_mission: "چشم‌انداز و ماموریت",
      manual_policies: "رهنمودها و پالیسی‌ها",
      saba_magazine: "مجله سبا",
      research_publications: "نشرات تحقیقی",

    student: "محصلان",
      eligibility_criteria: "شرایط شمولیت",
      scholarships_financing: "بورسیه‌ها و حمایت مالی",
      migration_policy: "پالیسی تبدیلی",
      semester_promotion_rules: "اصول ارتقای سمستر",
      penalties: "مجازات و تخلفات",

    saba_library: "کتابخانه سبا",
    news: "اخبار",
    job_opportunity: "فرصت کاری",
    kankor: "کانکور",
      online_admission: "پذیرش آنلاین",
      result: "نتیجه",
      kankor_results: "نتایج کانکور",
      kankor_result_portal: "پورتال رسمی نتایج",
      saba_university: "پوهنتون سبا",
      student_id: "آی‌دی محصل",
      student_name: "نام محصل",
      father_name: "نام پدر",
      grandfather_name: "نام پدرکلان",
      selected_faculty: "پوهنځی انتخاب‌شده",
      kankor_marks: "نمرات کانکور",
      result_status: "وضعیت نتیجه",
      student_type: "\u0646\u0648\u0639 \u0645\u062d\u0635\u0644",
      kankor_status_pass: "\u06a9\u0627\u0645\u06cc\u0627\u0628",
      kankor_status_fail: "\u0646\u0627\u06a9\u0627\u0645",
      grade_12: "\u0635\u0646\u0641 \u062f\u0648\u0627\u0632\u062f\u0647\u0645",
      grade_14: "\u0635\u0646\u0641 \u0686\u0647\u0627\u0631\u062f\u0647\u0645",
      maximum_marks: "\u0628\u0644\u0646\u062f\u062a\u0631\u06cc\u0646 \u0646\u0645\u0631\u0647",
      passing_score: "\u062d\u062f \u06a9\u0627\u0645\u06cc\u0627\u0628\u06cc",
      invalid_marks: "\u0646\u0645\u0631\u0627\u062a \u0646\u0627\u0645\u0639\u062a\u0628\u0631",
      marks_cannot_exceed: "\u0646\u0645\u0631\u0627\u062a \u0646\u0645\u06cc\u200c\u062a\u0648\u0627\u0646\u062f \u0627\u0632 \u062d\u062f \u062a\u0639\u06cc\u06cc\u0646\u200c\u0634\u062f\u0647 \u0628\u06cc\u0634\u062a\u0631 \u0628\u0627\u0634\u062f.",
      student_photo: "عکس محصل",
      enter_student_id: "آی‌دی محصل خود را وارد کنید",
      kankor_student_id_required: "لطفا آی‌دی محصل خود را وارد کنید.",
      kankor_student_id_invalid: "لطفا آی‌دی معتبر محصل را وارد کنید.",
      kankor_result_not_found: "برای این آی‌دی محصل نتیجه‌ای یافت نشد.",
      kankor_result_lookup_error: "جستجوی نتیجه موقتا در دسترس نیست. دوباره تلاش کنید.",
      kankor_result_share_description: "این نتیجه رسمی عمومی کانکور از پوهنتون سبا را مشاهده کنید.",
      kankor_result_search_hint: "با آی‌دی محصل، کارت رسمی نتیجه خود را به‌صورت خصوصی مشاهده کنید.",
      kankor_share_copied: "لینک اشتراک کاپی شد.",
      kankor_share_copy_failed: "کاپی نشد. لطفا لینک را دستی کاپی کنید.",
      kankor_share_ready: "لینک نتیجه برای اشتراک آماده است.",
      kankor_result_not_found_title: "نتیجه یافت نشد",
      kankor_result_not_found_detail: "ممکن است نتیجه مشترک‌شده حذف شده باشد یا لینک دیگر معتبر نباشد.",
      kankor_result_public_card: "کارت عمومی نتیجه",
      kankor_result_verified: "رکورد عمومی تایید شده",
      official: "رسمی",
      result_public_id: "آی‌دی عمومی نتیجه",
      share_result: "اشتراک نتیجه",
      share_result_hint: "این لینک عمومی امن را به دوستان یا خانواده بفرستید.",
      share_result_link: "لینک اشتراک نتیجه",
      copy_link: "کاپی لینک",
      print_result: "چاپ / ذخیره به عنوان PDF",
      share: "اشتراک",
    saba_economical_board: "بورد اقتصادی سبا",
    seb: "بورد اقتصادی سبا",
    nothing_to_show: "هنوز موردی برای نمایش وجود ندارد",
    no_posts: "پستی برای نمایش وجود ندارد",
    posts: "پست‌ها",
    post: "پست",
    chancellor_of_saba: "رئیس پوهنتون سبا",
    achievements: "دستاوردها",
    annual_two_semesters: "دو سمستر سالانه",
    a_about: "درباره",
    author: "نویسنده",
    page: "صفحه",
    related: "مرتبط",
    document: "سند",
    fullName: "نام کامل",
    fatherName: "نام پدر",
    faculty: "پوهنڅی",
    faculties: "لیسانس",
    id: "آی‌دی",
    yourDocuments: "اسناد شما",
    logOut: "خروج",
    graduated_date: "تاریخ فراغت",
    menu: "منو",
    saba_foundation: "بنیاد سبا",
    foundation: "بنیاد سبا",
    vission: "چشم‌انداز",
    mission: "ماموریت",
    structure: "ساختار",
    values: "ارزش‌ها",
    years_plane: "پلان استراتژیک پنج‌ساله",
    strategic_plane: "پلان استراتژیک",
    strategic_aims: "اهداف استراتژیک",
    downloadPlanFile: "دانلود فایل",
    councils_and_committees: "شوراها و کمیته‌ها",
    academic_programs: "برنامه‌های علمی",
    your_opinion: "نظر شما",
    write_opinion: "نظر خود را برای ما بنویسید",
    informational_technology: "تکنالوژی معلوماتی",
    it: "تکنالوژی معلوماتی",
    curriculum: "نصاب تحصیلی",
    labs: "لابراتوارها",
    library: "کتابخانه",
    libraryinfos: "معلومات کتابخانه",
    semester_fee: "فیس سمستر",
    software_engineering: "انجنیری نرم‌افزار",
    se: "انجنیری نرم‌افزار",
    information_system: "سیستم‌های معلوماتی",
    is: "سیستم‌های معلوماتی",
    national_economics: "اقتصاد ملی",
    neco: "اقتصاد ملی",
    banking: "بانکداری",
    beco: "بانکداری",
    business_administration: "اداره و تجارت",
    baeco: "اداره و تجارت",
    research_support: "حمایت تحقیقی",
    research_trainings: "آموزش‌های تحقیقی",
    policies_and_procedures : "پالیسی‌ها و طرزالعمل‌ها",
    research_papers_and_publication: "مقالات و نشرات تحقیقی",
    research_papers_and_publications: "مقالات و نشرات تحقیقی",
    scientific_and_research_magazine: "مجله علمی و تحقیقی",
    research_paper: "مقالات تحقیقی",
    research_guide: "رهنمای تحقیق",
    research_activities: "فعالیت‌های تحقیقی",
    activities: "فعالیت‌ها",
    planed_researche : "تحقیقات پلان‌شده",
    under_process_researche: "تحقیقات در حال اجرا",
    completed_researche: "تحقیقات تکمیل‌شده",
    published_researche: "تحقیقات نشرشده",
    publishedresearches: "تحقیقات نشرشده",

    annual_professional_development_plan: "پلان سالانه انکشاف مسلکی",
    seminars_courses_workshop: "سیمینارها، کورس‌ها و ورکشاپ‌ها",
    teacher: "استادان",
    administrative_staff: "کارمندان اداری",
    society: "جامعه",
    periodic_program_review: "بازنگری دوره‌ای برنامه",
    internal_accreditation: "اعتباردهی داخلی",
    national_accreditation: "اعتباردهی ملی",
    international_accreditation: "اعتباردهی بین‌المللی",
    offline_enrollment_requirement: "شرایط ثبت‌نام حضوری",
    kankor_guide: "رهنمای کانکور",
    kankor_registration_date : "تاریخ ثبت‌نام کانکور",
    enrolled : "شامل‌شده",
    general: "عمومی",
    activity: "فعالیت‌ها",
    online_library : "کتابخانه آنلاین",
    digital_library: "کتابخانه دیجیتال",
    offline_library : "کتابخانه حضوری",
    procedure: "طرزالعمل",
    study_statistic: "آمار مطالعه",
    progressive_plan:"پلان انکشافی",
    students_engagement:"مشارکت محصلان",
    students_experience: "تجربه‌های محصلان",
    tours_of_student: "سفرهای علمی محصلان",
    students_statistic: "آمار محصلان",
    statistic:"آمار",
    statistics:"آمار",
    tajil : "تاجیل",
    deprived: "محروم",
    chance: "چانس",
    re_enrollment: "شمولیت دوباره",
    eresticate: "انفکاک",
    transformation: "تبدیلی",
    repeat: "تکرار",
    graduate: "فارغان",
    cs_graduate: "فارغان کمپیوتر ساینس",
    eco_graduate: "فارغان اقتصاد",
    graduated_students_statistic: "آمار فارغان",
    employed_student: "محصلان استخدام‌شده",
    counseling_center: "مرکز مشاوره",
    pdc_student: "محصلان",
    cs: "کمپیوتر ساینس",
    eco: "اقتصاد",
    email: "ایمیل",
    phone: "تلفن",
    job: "وظیفه",
    startDate: "تاریخ آغاز",
    endDate: "تاریخ ختم",
    searchById: "جستجو با آی‌دی",
    search: "جستجو",
    search_open: "باز کردن جستجو",
    search_close: "بستن جستجو",
    search_clear: "پاک کردن جستجو",
    search_saba_university: "جستجوی پوهنتون سبا",
    search_page_title: "جستجوی پوهنتون",
    search_placeholder: "کنفرانس‌ها، سیمینارها، نشست‌ها و کمیته‌ها را جستجو کنید...",
    search_intro: "در میان فعالیت‌ها، رویدادهای علمی و کمیته‌های پوهنتون جستجو کنید.",
    search_minimum_hint: "برای جستجو حداقل ۲ حرف وارد کنید.",
    searching: "در حال جستجو...",
    search_unavailable: "جستجو موقتاً در دسترس نیست. دوباره تلاش کنید.",
    search_no_results: "نتیجه‌ای یافت نشد برای",
    search_try_broader: "کلیدواژه عمومی‌تر یا دسته دیگری را امتحان کنید.",
    search_all: "همه",
    search_conferences: "کنفرانس‌ها",
    search_seminars: "سیمینارها",
    search_meetings: "نشست‌ها / بحث‌ها",
    search_committees: "کمیته‌ها",
    search_filter_label: "دسته‌های جستجو",
    search_results: "نتایج جستجو",
    search_results_for: "نتیجه برای",
    search_view_all_results: "مشاهده همه نتایج",
    search_recent: "جستجوهای اخیر",
    search_previous: "قبلی",
    search_next: "بعدی",
    board: "بورد",
    more: "بیشتر",
    student_services: "خدمات محصلان",
    policies_counsel: "پالیسی‌ها و مشاوره",
    resourses: "منابع",
    support_services: "خدمات حمایوی",
    alumni_support_services: "فارغان و خدمات حمایوی",
    enrollment_information: "معلومات شمولیت",
    guidance_general: "رهنمایی و معلومات عمومی",
    guidelines: "رهنمودها",
    institutions: "نهادها",
    find_out_more: "بیشتر بدانید",
    latest_posts: "آخرین پست‌ها",
    it_information: "شبکه تکنالوژی معلوماتی به طراحی، پیاده‌سازی و مدیریت شبکه‌های کمپیوتر برای ارتباطات داده گفته می‌شود و شامل تجهیزات شبکه، پروتوکول‌ها، امنیت و رفع مشکلات برای اتصال مصون و موثر است.",
    se_information: "انجنیری نرم‌افزار روند طراحی، توسعه، آزمایش و نگهداری برنامه‌های نرم‌افزاری با استفاده از اصول انجنیری است و بر ساخت راه‌حل‌های قابل اعتماد، مقیاس‌پذیر و موثر تمرکز دارد.",
    is_information: "سیستم‌های معلوماتی بر جمع‌آوری، پردازش، ذخیره‌سازی و توزیع معلومات با استفاده از تکنالوژی تمرکز دارد و نرم‌افزار، سخت‌افزار و مدیریت داده را برای پشتیبانی از تصمیم‌گیری یکجا می‌سازد.",
    neco_economics: "اقتصاد ملی ساختار کلی اقتصاد یک کشور را بررسی می‌کند؛ از تولید و مصرف تا تجارت و پالیسی‌های دولتی، و بر رشد اقتصادی، تورم، استخدام و مدیریت مالی تمرکز دارد.",
    beco_economics: "بانکداری مدیریت معاملات مالی مانند سپرده‌ها، قرضه‌ها، سرمایه‌گذاری‌ها و پرداخت‌ها است و با فراهم‌سازی خدمات مالی برای افراد، تجارت‌ها و دولت‌ها در رشد اقتصادی نقش مهم دارد.",
    baeco_economics: "اداره تجارت روند پلان‌گذاری، تنظیم و مدیریت فعالیت‌های تجارتی برای دستیابی به موثریت و رشد است و بخش‌هایی مانند مالی، بازاریابی، منابع بشری و تصمیم‌گیری استراتژیک را در بر می‌گیرد.",
    training_about_pdc: "آموزش و درباره PDC",
    explore_more: "بیشتر جستجو کنید",
    activities_explore: "فعالیت‌ها و جستجوی بیشتر",
    activities_resources: "فعالیت‌ها و منابع",
    quality_accreditation: "تضمین کیفیت و اعتباردهی",
    achievements_progress: "دستاوردها و پیشرفت",
    enrollment_guidance: "شمولیت و رهنمایی",
    computer_science_alumni : "فارغان کمپیوتر ساینس",
    economic_alumni : "فارغان اقتصاد",
    name: "نام",
    who_we_are: "ما که هستیم",
    latest_news: "آخرین اخبار",
    see_more : "بیشتر ببینید",
    lab : "لابراتوار",
    home_hero_label: "بخش هیروی صفحه اصلی پوهنتون سبا",
    home_hero_eyebrow: "پوهنتون سبا",
    home_hero_title: "سبا شما را می‌سازد تا شما آیندهٔ خود را بسازید!",
    home_hero_description: "برنامه های علمی، پذیرش، خدمات محصلان، تحقیق و تازه ترین معلومات پوهنتون را در یک جای روشن دنبال کنید.",
    home_apply_now: "ثبت نام آنلاین",
    home_explore_programs: "مشاهده برنامه ها",
    home_intro_eyebrow: "معرفی کوتاه پوهنتون",
    home_intro_title: "محیط علمی متمرکز برای متخصصان آینده افغانستان",
    home_intro_body: "پوهنتون سبا تحصیلات عالی محصل محور را با کیفیت علمی، آموزش عملی و خدمت به جامعه فراهم می سازد.",
    home_stat_faculties: "مسیرهای علمی",
    home_stat_faculties_hint: "کمپیوتر ساینس، اقتصاد و انکشاف مسلکی",
    home_stat_news: "تازه های پوهنتون",
    home_stat_news_hint: "اخبار و اعلانات نشر شده",
    home_stat_research: "نکات تحقیقی",
    home_stat_research_hint: "آخرین آثار علمی نشر شده",
    home_value_quality_title: "کیفیت علمی",
    home_value_quality_text: "برنامه های روشن، تضمین کیفیت و حمایت منظم آموزشی.",
    home_value_practical_title: "آموزش عملی",
    home_value_practical_text: "لابراتوارها، فعالیت های تحقیقی، سیمینارها و تجربه های عملی محصلان.",
    home_value_student_title: "حمایت از محصل",
    home_value_student_text: "راهنمایی پذیرش، کتابخانه و خدمات محصلان.",
    home_programs_eyebrow: "برنامه های علمی",
    home_programs_title: "برنامه ای را با مسیر علمی روشن انتخاب کنید",
    home_programs_body: "از پوهنځی های اصلی آغاز کنید و نصاب، لابراتوارها، فیس، تقویم و معلومات کیفیت را دنبال نمایید.",
    home_program_cs_desc: "کمپیوتر، نرم افزار، سیستم های معلوماتی و مهارت های عملی دیجیتال.",
    home_program_eco_desc: "اقتصاد، بانکداری، اداره و تجارت، و آمادگی عملی برای بازار کار.",
    home_admission_eyebrow: "پذیرش",
    home_admission_title: "ثبت نام باید آسان پیدا و آسان آغاز شود",
    home_admission_body: "محصلان آینده می توانند شرایط را ببینند، ثبت نام آنلاین را باز کنند و نتایج رسمی کانکور را از صفحه اصلی بررسی نمایند.",
    home_registration_update: "معلومات ثبت نام",
    home_academic_event: "رویداد علمی",
    home_empty_updates: "تازه های پذیرش پس از نشر در اینجا نمایش داده می شود.",
    home_news_eyebrow: "اخبار و اعلانات",
    home_news_title: "در پوهنتون سبا چه تازه است",
    home_news_body: "تازه ترین معلومات عمومی، اعلانات و فعالیت های پوهنتون از وبسایت رسمی.",
    home_empty_news: "آخرین اخبار پوهنتون پس از نشر در اینجا نمایش داده می شود.",
    home_highlights_eyebrow: "زندگی علمی",
    home_highlights_title: "تحقیق، دستاوردها و فعالیت های محصلان",
    home_highlights_body: "نمای متمرکز از کارهای علمی و فعالیت هایی که زندگی پوهنتون را برای محصلان روشن می سازد.",
    home_view_activities: "مشاهده فعالیت ها",
    home_empty_highlights: "نکات علمی پس از نشر در اینجا نمایش داده می شود.",
    home_quick_links_eyebrow: "دسترسی سریع",
    home_quick_links_title: "خدمات مهم برای محصلان و بازدیدکنندگان",
    home_quick_links_body: "کارهای رایج اینجا گروه بندی شده تا محصلان سریع به خدمت مناسب برسند.",
    home_apply_detail: "ثبت نام خود را آغاز کنید",
    home_result_detail: "نتایج رسمی را جستجو کنید",
    home_library_detail: "استفاده از منابع علمی",
    home_contact_detail: "آدرس و حمایت را پیدا کنید",
    home_contact_eyebrow: "بازدید یا تماس",
    home_contact_title: "با پوهنتون سبا در تماس شوید",
    home_contact_body: "برای پذیرش، برنامه های علمی، اسناد یا حمایت عمومی، از معلومات رسمی تماس استفاده کنید.",
    loading: "در حال بارگذاری...",
    loading_data: "در حال بارگذاری معلومات...",
    loading_website: "در حال بارگذاری وب‌سایت...",
    loading_navbar: "در حال بارگذاری راهنما...",
    loading_footer: "در حال بارگذاری فوتر...",
    loading_page: "صفحه در حال بارگذاری است...",
    page_load_error_title: "این صفحه بارگذاری نشد",
    page_load_error_message: "یک بخش وب‌سایت درست بارگذاری نشد. لطفا صفحه را دوباره بارگذاری کنید.",
    reload_page: "بارگذاری دوباره صفحه",
    please_wait: "لطفا صبر کنید...",
    fetching_books: "در حال دریافت کتاب‌ها...",
    finding_results: "در حال جستجوی نتایج...",
    sending: "در حال ارسال...",
    send: "ارسال",
    sending_opinion: "در حال ارسال نظر شما...",
    page_not_found: "صفحه یافت نشد",
    primary_navigation: "راهنمای اصلی",
    language_selector: "انتخاب زبان",
    saba_university_home: "صفحه اصلی پوهنتون سبا",
    open_menu: "باز کردن منو",
    close_menu: "بستن منو",
    previous_image: "تصویر قبلی",
    next_image: "تصویر بعدی",
    open_image_viewer: "باز کردن نمایشگر تصویر",
    close_image_viewer: "بستن نمایشگر تصویر",
    image_viewer: "نمایشگر تصویر",
    gallery_navigation: "راهنمای تصاویر گالری",
    gallery_thumbnails: "تصاویر کوچک گالری",
    breadcrumb: "مسیر راهنما",
    page_header: "سرصفحه",
    media_gallery: "گالری رسانه‌ای پوهنتون سبا",
    no_gallery_image: "تصویر گالری موجود نیست",
    gallery_image: "تصویر پوهنتون سبا",
    pagination: "صفحه‌بندی",
    related_links: "لینک‌های مرتبط",
    date: "تاریخ",
    download: "دانلود",
    book_name: "نام کتاب",
    book_image: "تصویر کتاب",
    search_by: "جستجو بر اساس",
    search_by_required: "نوع جستجو *",
    search_by_book_id_or_name: "بر اساس آی‌دی، نام یا نویسنده",
    search_book: "جستجوی کتاب",
    search_book_required: "جستجوی کتاب *",
    search_book_placeholder: "آی‌دی، نام یا نویسنده کتاب *",
    library_search_hint: "کتاب‌ها را بر اساس آی‌دی، نام یا نویسنده جستجو کنید.",
    all_inputs_required: "لطفا تمام معلومات ضروری را تکمیل کنید.",
    library_search_type_invalid: "لطفاً بر اساس آی‌دی، نام یا نویسنده کتاب جستجو کنید.",
    login: "ورود",
    student_password: "رمز عبور محصل",
    student_password_required: "رمز عبور محصل *",
    enter_id_required: "آی‌دی را وارد کنید *",
    enter_password_required: "رمز عبور را وارد کنید *",
    student_id_required_label: "آی‌دی محصل *",
    student_documents_title: "اسناد محصلان پوهنتون سبا",
    student_id_required_message: "آی‌دی محصل ضروری است.",
    student_id_invalid_message: "لطفا آی‌دی معتبر محصل را وارد کنید.",
    field_input_required: "ضروری است.",
    no_graduated_student_found: "محصل فارغ با این آی‌دی یافت نشد.",
    registration_form_title: "معلومات ثبت نام آنلاین را تکمیل کنید.",
    full_name_required: "نام کامل *",
    name_required: "نام *",
    pashto_full_name_required: "نام کامل پشتو *",
    pashto_name_required: "نام پشتو *",
    dari_full_name_required: "نام کامل دری *",
    dari_name_required: "نام دری *",
    father_name_required: "نام پدر *",
    father_name_placeholder: "نام پدر *",
    pashto_father_name_required: "نام پدر به پشتو *",
    dari_father_name_required: "نام پدر به دری *",
    graduation_year_required: "سال فراغت *",
    graduation_year_placeholder: "سال فراغت",
    high_school_name_required: "نام مکتب *",
    school_name_required: "نام مکتب *",
    pashto_high_school_name_required: "نام مکتب به پشتو *",
    pashto_school_name_required: "نام مکتب به پشتو *",
    dari_high_school_name_required: "نام مکتب به دری *",
    dari_school_name_required: "نام مکتب به دری *",
    phone_number_required: "شماره تلفن *",
    phone_number_placeholder: "شماره تلفن *",
    province_required: "ولایت *",
    pashto_province_required: "ولایت به پشتو *",
    dari_province_required: "ولایت به دری *",
    email_address: "آدرس ایمیل",
    register: "ثبت نام",
    registration_success: "ثبت نام با موفقیت انجام شد.",
    submission_success: "با موفقیت ارسال شد.",
    opinion_min_length: "نظر نباید کمتر از ۳۰ حرف باشد.",
    read_more: "بیشتر بخوانید",
    student_image: "تصویر محصل",
    post_image: "تصویر پست",
    member_image: "تصویر عضو",
    afghanistan_flag: "بیرق افغانستان",
    united_states_flag: "بیرق ایالات متحده",
    expiring_on: "تاریخ ختم",
    contact_form_title: "با پوهنتون سبا در تماس شوید",
    contact_form_body: "برای پذیرش، برنامه های علمی، اسناد یا حمایت عمومی از فورم رسمی تماس استفاده کنید.",
    subject: "موضوع",
    message: "پیام",
    submit_message: "ارسال پیام",
    contact_information: "معلومات تماس",
    address: "آدرس",
    office_hours: "اوقات کاری",
    office_hours_value: "شنبه تا پنجشنبه، 05:00 صبح - 08:00 شب",
    official_channels: "کانال های رسمی",
    message_submitted_success: "پیام با موفقیت ارسال شد.",
    required_suffix: "ضروری است.",
    online_registration: "ثبت نام آنلاین",
    registration_date: "تاریخ ثبت نام",
    registration_shamsi_date: "تاریخ ثبت نام (شمسی)",
    from_date: "از تاریخ",
    to_date: "تا تاریخ",
    invalid_shamsi_date: "تاریخ شمسی/جلالی نامعتبر است.",
    no_registration_date: "تاریخ ثبت نام موجود نیست",
    online_registration_subtitle: "نوع فراغت خود را انتخاب کنید، سپس فورم رسمی A4 ثبت نام پوهنتون سبا را تکمیل کنید.",
    choose_application_type: "نوع درخواست را انتخاب کنید",
    registration_step_type: "نوع فراغت",
    registration_step_faculty: "پوهنځی",
    registration_step_form: "فورم رسمی",
    registration_step_card: "کارت ورود",
    choose_faculty: "پوهنځی را انتخاب کنید",
    select_faculty: "انتخاب پوهنځی",
    faculty_required: "لطفا پیش از باز کردن فورم رسمی، پوهنځی را انتخاب کنید.",
    no_faculties_available: "در حال حاضر هیچ پوهنځی برای ثبت نام آنلاین فعال نیست.",
    change_faculty: "تغییر پوهنځی",
    registration_faculty_hint: "تنها پوهنځی هایی نمایش داده می شوند که از طرف اداره برای ثبت نام آنلاین فعال شده اند.",
    registration_form_locked_until_faculty: "برای باز کردن فورم رسمی ثبت نام، یک پوهنځی فعال را انتخاب کنید.",
    grade_12_application: "فارغ صنف دوازدهم",
    grade_14_application: "فارغ صنف چهاردهم / تعلیمات نیمه عالی",
    master_application: "برنامه ماستری مدیریت تجارت / MBA",
    choose_program: "انتخاب برنامه",
    selected_program: "برنامه",
    master_registration_notice: "دسترسی برنامه ماستری توسط اداره پذیرش تعیین می‌شود.",
    master_registration_closed: "ثبت‌نام ماستری در حال حاضر بسته است.",
    registration_confirmation: "تایید",
    registration_required: "الزامی",
    registration_optional: "اختیاری",
    registration_invalid_value: "لطفا معلومات {field} را اصلاح کنید.",
    registration_admin_assigned: "تعیین توسط اداره",
    loading_online_registration: "در حال بارگذاری ثبت نام آنلاین...",
    online_registration_unavailable: "ثبت نام آنلاین فعلا در دسترس نیست.",
    registration_closed: "ثبت نام بسته است",
    change_type: "تغییر نوع",
    submit_official_form: "ثبت نام نهایی",
    update_previous_submission: "تبدیل / به‌روزرسانی درخواست قبلی",
    submitting: "در حال ارسال...",
    print_form: "چاپ فورم",
    download_pdf: "دانلود PDF",
    registration_submitted: "ثبت‌نام شما با موفقیت انجام شد",
    registration_submitted_copy: "فورم شما با موفقیت ثبت و ذخیره شد.",
    registration_updated: "ثبت‌نام شما با موفقیت به‌روز شد",
    registration_updated_copy: "معلومات ثبت‌نام شما با موفقیت به‌روز و ذخیره شد.",
    kankor_entry_card: "کارت رسمی ورود به کانکور",
    kankor_entry_card_copy: "این کارت از فورم ثبت نام ارسال‌شده شما ساخته می‌شود. در صورت ضرورت، پس از تایید تاریخ امتحان و آی‌دی آن را چاپ کنید.",
    fix_required_fields: "لطفا قبل از ارسال، بخش‌های مشخص‌شده در فورم رسمی را تکمیل کنید.",
    duplicate_registration_warning: "ثبت نام موجود یافت شد. ادامه دادن معلومات قبلی ارسال‌شده شما را تبدیل/به‌روزرسانی می‌کند.",
    duplicate_confirmation: "من می‌دانم و می‌خواهم معلومات قبلی ارسال‌شده خود را تبدیل/به‌روزرسانی کنم.",
    photo_required: "عکس محصل ضروری است.",
    identity_document_required: "لطفا تذکره الکترونیکی، پاسپورت، یا شماره ثبت/عمومی تذکره کاغذی را وارد کنید.",
    official_form_timeout: "فورم رسمی پاسخ نداد. لطفا صفحه را دوباره بارگذاری کنید و دوباره تلاش کنید.",
    valid_email_required: "لطفا آدرس ایمیل معتبر را وارد کنید.",
    official_form_ready: "فورم رسمی آماده است",
    loading_official_form: "در حال بارگذاری فورم رسمی...",
    submitted: "ارسال‌شده",
    footer_about_text: "پوهنتون سبا تحصیلات عالی منظم، خدمات محصلان، فعالیت های تحقیقی و برنامه های علمی جامعه محور را فراهم می سازد.",
    footer_links_title: "لینک های مهم",
    footer_copyright: "حق نشر",
  }


});


const localizedFieldKey = (prefix, field) =>
  prefix + field.charAt(0).toUpperCase() + field.slice(1);

export const getLocalizedField = (record, field, languageCode = languages.getLanguage()) => {
  if (!record || !field) return "";

  const normalizedLanguage = normalizeLanguage(languageCode);
  const englishKey = field;
  const pashtoKey = localizedFieldKey("p", field);
  const dariKey = localizedFieldKey("d", field);
  const keysByLanguage = {
    en: [englishKey, dariKey, pashtoKey],
    ps: [pashtoKey, englishKey, dariKey],
    fa: [dariKey, englishKey, pashtoKey],
  };

  for (const key of keysByLanguage[normalizedLanguage]) {
    const value = record?.[key];
    if (value !== undefined && value !== null && value !== "") return value;
  }

  return "";
};

languages.normalizeLanguage = normalizeLanguage;
languages.getLanguageDirection = getLanguageDirection;
languages.setDocumentLanguage = setDocumentLanguage;
languages.getLocalizedField = getLocalizedField;
languages.isRTL = (languageCode = languages.getLanguage()) =>
  getLanguageDirection(languageCode) === "rtl";

setDocumentLanguage(normalizeLanguage(languages.getLanguage()));

export default languages;
